/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Tab_StudioInputs */

const en_ui_labs_tab_studio = /** @type {(inputs: Ui_Labs_Tab_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const de_ui_labs_tab_studio = /** @type {(inputs: Ui_Labs_Tab_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Ui_Labs_Tab_StudioInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_tab_studio = /** @type {((inputs?: Ui_Labs_Tab_StudioInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Tab_StudioInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_tab_studio(inputs)
	return de_ui_labs_tab_studio(inputs)
});